export interface ISortConfig {
  direction?: 'asc' | 'desc';
  getA: (value) => string;
  getB: (value) => string;
}

const defaultGetValue = (value) => value;
const defaultConfigValues: ISortConfig = { direction: 'asc', getA: defaultGetValue, getB: defaultGetValue };

export function sortAlphabetically<T = string>(array: T[], config: ISortConfig = defaultConfigValues): T[] {
  const { direction = 'asc', getA = defaultGetValue, getB = defaultGetValue } = config;

  return [...array].sort((a, b) => {
    const aValue = getA(a);
    const bValue = getB(b);

    let comparation = aValue.localeCompare(bValue);

    if (direction === 'desc') {
      comparation = -comparation;
    }

    return comparation;
  });
}
